/*
Bones Scripts File
Author: Eddie Machado

This file should contain any js scripts you want to add to the site.
Instead of calling it in the header or throwing it inside wp_head()
this file will be called automatically in the footer so as not to
slow the page load.

*/

// IE8 ployfill for GetComputed Style (for Responsive Script below)
;if (!window.getComputedStyle) {
  window.getComputedStyle = function (el, pseudo) {
    this.el = el
    this.getPropertyValue = function (prop) {
      const re = /(-([a-z]){1})/g
      if (prop === 'float') { prop = 'styleFloat' }
      if (re.test(prop)) {
        prop = prop.replace(re, function () {
          return arguments[ 2 ].toUpperCase()
        })
      }
      return el.currentStyle[ prop ] ? el.currentStyle[ prop ] : null
    }
    return this
  }
}

// as the page loads, call these scripts
;jQuery(document).ready(function ($) {
  /*
  Responsive jQuery is a tricky thing.
  There's a bunch of different ways to handle
  it, so be sure to research and find the one
  that works for you best.
  */

  /* getting viewport width */
  const responsiveViewport = $(window).width()

  /* if is below 481px */
  if (responsiveViewport < 481) {

  }
  /* end smallest screen */

  /* if is larger than 481px */
  if (responsiveViewport > 481) {

  }
  /* end larger than 481px */

  /* if is above or equal to 768px */
  if (responsiveViewport >= 768) {
    /* load gravatars */
    $('.comment img[data-gravatar]').each(function () {
      $(this).attr('src', $(this).attr('data-gravatar'))
    })
  }

  /* off the bat large screen actions */
  if (responsiveViewport > 1030) {

  }

  // add all your scripts here
})
/* end of as page load scripts */

/*! A fix for the iOS orientationchange zoom bug.
 Script by @scottjehl, rebound by @wilto.
 MIT License.
*/
// (function (w) {
//   // This fix addresses an iOS bug, so return early if the UA claims it's something else.
//   if (!(/iPhone|iPad|iPod/.test(navigator.platform) && navigator.userAgent.indexOf('AppleWebKit') > -1)) { return }
//   const doc = w.document
//   if (!doc.querySelector) { return }
//   const meta = doc.querySelector('meta[name=viewport]')
//   const initialContent = meta && meta.getAttribute('content')
//   const disabledZoom = initialContent + ',maximum-scale=1'
//   const enabledZoom = initialContent + ',maximum-scale=10'
//   let enabled = true
//   let x = null
//   let y = null
//   let z = null
//   let aig = null
//   if (!meta) { return }
//
//   function restoreZoom () {
//     meta.setAttribute('content', enabledZoom)
//     enabled = true
//   }
//
//   function disableZoom () {
//     meta.setAttribute('content', disabledZoom)
//     enabled = false
//   }
//
//   function checkTilt (e) {
//     aig = e.accelerationIncludingGravity
//     x = Math.abs(aig.x)
//     y = Math.abs(aig.y)
//     z = Math.abs(aig.z)
//     // If portrait orientation and in one of the danger zones
//     if (!w.orientation && (x > 7 || ((z > 6 && y < 8 || z < 8 && y > 6) && x > 5))) { // eslint-disable-line
//       if (enabled) {
//         disableZoom()
//       }
//     } else if (!enabled) {
//       restoreZoom()
//     }
//   }
//
//   w.addEventListener('orientationchange', restoreZoom, false)
//   w.addEventListener('devicemotion', checkTilt, false)
// })(this)
